import http from '@/http-common'
import Tab from '../../components/TabSpr.vue'

export default {
    name: 'school',
    components: {Tab},
    props: {
        isCalled: {
            type: Boolean,
            default: false,
        },
        columns: {
            type: Array,
            default: () => [
                {key: 'code', label: 'Код'},
                {key: 'name', label: 'Наименование', sortable: true, sorted: true},
                {key: 'shortName', label: 'Краткое наименование', sortable: true, sorted: true},
                {key: 'adress', label: 'Адрес', sortable: true, sorted: true},
                {key: 'director', label: 'Директор', sortable: true, sorted: true},
                {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
            ],
        }
    },
    data() {
        return {
            isBusy: false,
            captionTable: 'Справочник школ',
            selectedItem: {
                name: '',
                code: '',
                adress: '',
                director: '',
                phones: []
            },
            captionSpr: {
                name: 'Школы',
                nameR: 'Школы'
            },
            items: [],
            urls: {
                save: '/school/save',
                delete: '/school/delete',
            },
            modalEditOpened: false,
            validValue: {
                name: true,
                adress: true,
                director: true,
                phones: true,
                form: true
            },
            columnsPhone: [
                {key: 'phoneType', label: 'Тип'},
                {key: 'phone', label: 'Номер телефона'},
                {key: 'edit_field', label: '', class: 'width10', sortable: false}
            ],
            phoneTypes: []
        }
    },
    created() {
        this.loadItems();
    },
    methods: {
        checkForm() {
            for (var key in this.validValue) {
                this.validValue[key] = true;
            }
            if (!this.selectedItem.name || this.selectedItem.name == '') {
                this.validValue.name = false;
                this.validValue.form = false;
            }
            if (!this.selectedItem.adress || this.selectedItem.adress == '') {
                this.validValue.adress = false;
                this.validValue.form = false;
            }
            if (!this.selectedItem.director || this.selectedItem.director == '') {
                this.validValue.director = false;
                this.validValue.form = false;
            }
            var vm = this
            if (this.selectedItem.phones) {
                this.selectedItem.phones.forEach(function (x) {
                    if (!x.phone || x.phone == '' ||
                        !x.phoneType || x.phoneType == '' ){
                        vm.validValue.phones = false
                        vm.validValue.form = false
                    }
                })
            }
        },
        loadItems() {
            var vm = this;
            this.isBusy = true;
            http.get('/school/list')
                .then((response) => {
                    vm.items = response.data;
                })
                .catch((error) => console.log(error.message))
                .finally(() => vm.isBusy = false);
        },
        showEditDialog() {
            if (this.isCalled && this.selectedItem.id > 0) {
                this.rowSelected([this.selectedItem]);
                this.$emit('selectItem')
            } else {
                this.loadPhoneTypes()
                this.modalEditOpened = !this.modalEditOpened;
            }
        },
        saveItem() {
            this.checkForm();
            if (this.validValue.form) {
                this.modalEditOpened = false;
                this.$refs.SchoolTab.save(this.selectedItem);
            }
        },
        addPhone() {
            var phone = {
                id: 0,
                phone: '',
                phoneType: null
            };
            this.selectedItem.phones.push(phone);
        },
        deletePhone(index) {
            this.selectedItem.phones.splice(index,1)
        },
        loadPhoneTypes() {
            var vm = this;
            http.get('/phonetype/list')
                .then((response) => {
                    vm.phoneTypes = response.data;
                })
                .catch((error) => console.log(error.message));
        },
    }
}
